import gql from 'graphql-tag';

export default gql`
  subscription UpdateClientList {
    updateClientList {
      id
    }
  }
`;
